/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { IntraSedationDtoResponse } from '../models/IntraSedationDtoResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class IntraSedationService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @param patientId
     * @param sedationId
     * @returns IntraSedationDtoResponse Success
     * @throws ApiError
     */
    public getApiIntraSedationPatientSedationDetailHistoricalData(
        patientId: string,
        sedationId: string,
    ): CancelablePromise<IntraSedationDtoResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/IntraSedation/Patient/{patientId}/SedationDetail/{sedationId}/HistoricalData',
            path: {
                'patientId': patientId,
                'sedationId': sedationId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Server Error`,
            },
        });
    }
}
